<template>
    <div full-height grey-back>
        <!-- <v-toolbar flat fixed>
            <v-toolbar-title>Bizops App</v-toolbar-title>
        </v-toolbar> -->

        <div grey-back>

            <v-list two-line nopadding v-if="$root.CurrentBusiness && $root.CurrentBusiness.UserName">

               <v-list-tile avatar v-ripple>

                    <v-list-tile-avatar class="avatar-with-background">
                        <!-- <img :src="$root.CurrentBusiness.businessLogo" v-if="$root.CurrentBusiness.businessLogo"/> -->
                        <!-- <template v-else>{{$root.fn_abbreviatedBusinessName()}}</template> -->
                        {{$root.fn_abbreviatedName($root.CurrentBusiness.UserName)}}
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title>{{$root.CurrentBusiness.UserName}}</v-list-tile-title>
                        <v-list-tile-sub-title>View business details</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                
                </v-list-tile>

            </v-list>

            <!-- <v-alert :value="true" color="info" transition="slide-y-transition" v-if="$root.CurrentBusiness">Hi! {{$root.CurrentBusiness.UserName}}</v-alert> -->
            <v-list nopadding>
              <v-list-tile v-ripple @click="fn_scanQRCode">

                <v-list-tile-action>
                  <v-icon color="primary">computer</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Desktop Login</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon color="primary">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile v-ripple @click="fn_changeUserType">

                <v-list-tile-action>
                  <v-icon color="primary">sync</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Change User Type</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon color="primary">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile v-ripple @click="fn_updateBusiness">

                <v-list-tile-action>
                  <v-icon color="primary">edit</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Update Profile</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon color="primary">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile v-ripple @click="fn_updateBusiness('register')">

                <v-list-tile-action>
                  <v-icon color="primary">business</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Register Business</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon color="primary">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile v-ripple @click="fn_changeNumber">

                <v-list-tile-action>
                  <v-icon color="primary">smartphone</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Change Number</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon color="primary">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list> 
            
        </div>
        
<!-- 
        <v-footer fixed :height="64">
            <v-layout row wrap ma-0 v-if="!isSkip">
                <v-flex xs4 sm4 md4>
                    <v-btn text color="primary" v-if="userType===2" large @click="isSkip=true">Skip</v-btn>
                </v-flex>

                <v-flex xs8 sm8 md8 right-align>
                    <v-btn color="primary" large @click="fn_getToken('register')">Register Business</v-btn>
                </v-flex>
            </v-layout>

            <v-layout row wrap ma-0 v-else>
                <v-flex xs12 sm12 md12 right-align>
                    <v-btn color="primary" large block @click="fn_getToken">Save</v-btn>
                </v-flex>
            </v-layout>
        </v-footer> -->
    </div>
</template>

<script>
    export default{
        // data(){
        //     return{
        //         userType:1,
        //         isSkip:false,
        //         userName:null
        //     }
        // },

        methods:{

            fn_changeUserType: function(){
                this.$router.push({path:"/registration/business/usertype"});
            },

            fn_updateBusiness: function(type){
              if(type=='register'){
                this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit', query:{usertype:this.$root.CurrentBusiness.UserType}});
              }
              else{
                this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
              }
            },

            fn_comingsoon: function(){
                this.showToast("Under development!");
            },

            fn_scanQRCode: function(){
                let self = this;

                this.showLoading("Please wait...");

                this.$root.fn_getAuthToken(function(token){
                  
                  self.hideLoading();

                  let postObj = {}
                  postObj.BusinessID = self.$root.CurrentBusiness.BusinessID;
                  postObj.token = token;
                  postObj.IsTemporary = false;

                  self.postServerData('DesktopLogin', postObj, 
                      {
                        onSuccess: function(response){
                          console.log(response);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                      }
                    ); 
                });
            },

            // fn_newBusiness: function(){
            //     this.$router.replace({path:'/registration/business/register', query:{"mobile_number":this.$route.query.mobileNumber, 'user_name':this.userName}});
            // },

            fn_getToken: function(type){

                this.showLoading('Please wait...');
                this.$root.fn_getAuthToken(token=>{
                    if(token == 'error'){
                        this.hideLoading();
                    }
                    else{
                        this.fn_setUserType(token, type);
                    }
                })
            },

            fn_changeNumber: function(){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    return;
                }
                this.fn_openSecurityLock();
            },

            fn_openSecurityLock: function(){
                let self = this;
                this.getData('VerifyScreenLock', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            // self.fn_openDialogMatchBusiness();
                            let status = JSON.parse(response);
                            if(status){
                                self.fn_confirmChangeNumber();
                            }
                        },
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_confirmChangeNumber: function(){
                let self = this;
                setTimeout(function(){
                    self.$router.push({path:"/registration/business/change_phone_number"});
                })
            },
        },

        mounted: function(){
            // this.userName = this.$route.query.userName;
            window.js_globals.fn_onBackPress = this.exitApp;
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/accountant/accountant_landing.vue